/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const SalesOrderPlanningService = {

  async savePTStatus(payload) {
    const url = `api/SalesOrderDetailAttribute/BulkUpdate`;
    return await ApiService.post(url, payload);
  },

};

export { SalesOrderPlanningService };
